import { Lead } from '../../lead';

export class NegocioQualificacaoCreate {
    idFunilVenda: number;
    novoLead: boolean;
    idLead: number;
    lead: Lead;
    idUsuarioResponsavel: number;
    prioridade: number;
    dataPrevisaoFechamento: Date;
    valor: number;
    idCampanha: number;
}
